var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showMandatoryError
        ? _c("div", { staticClass: "error mb-3" }, [
            _vm._v("\n\t\t" + _vm._s(_vm.mandatoryErrorMessage) + "\n\t")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.nothingEligible
        ? _c(
            "div",
            { staticClass: "mb-3" },
            [
              _c(
                "b-form-checkbox",
                {
                  on: { input: _vm.nothingChanged },
                  model: {
                    value: _vm.nothing,
                    callback: function($$v) {
                      _vm.nothing = $$v
                    },
                    expression: "nothing"
                  }
                },
                [
                  _c("span", {
                    domProps: { innerHTML: _vm._s(_vm.nothingText) }
                  })
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.nothing
        ? _vm._l(_vm.meta.geoRegion, function(region) {
            return _c("div", { key: region.id, staticClass: "mb-3" }, [
              _c("div", [
                _c(
                  "a",
                  {
                    staticClass: "text-decoration-none",
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.toggleRegion(region)
                      }
                    }
                  },
                  [
                    _c("Icon", {
                      attrs: {
                        icon: "caret-up",
                        rotate: _vm.isRegionOpen(region) ? 180 : 90
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "ml-1" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(region.label) +
                          "\n\t\t\t\t\t\t"
                      ),
                      _vm.getSelectedCount(region)
                        ? _c("span", [
                            _vm._v(
                              "(" + _vm._s(_vm.getSelectedCount(region)) + ")"
                            )
                          ])
                        : _vm._e()
                    ])
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _vm.isRegionOpen(region)
                ? _c(
                    "div",
                    { staticClass: "mt-3 pl-3" },
                    _vm._l(region.countries, function(country) {
                      return _c(
                        "div",
                        { key: country.id, staticClass: "mb-1" },
                        [
                          _c(
                            "b-form-checkbox",
                            {
                              attrs: { checked: _vm.isSelected(country) },
                              on: {
                                change: function($event) {
                                  return _vm.countryChanged(country, $event)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(country.text) +
                                  "\n\t\t\t\t\t"
                              )
                            ]
                          )
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _vm._e()
            ])
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }